import React, { MutableRefObject } from "react";

export interface Props {
  reference: MutableRefObject<any>;
}

const PrintingAnimation: React.FC<Props> = ({ reference }) => {
  return (
    <div ref={reference} className="dqm-tcui-printing-animation">
      <div className="dqm-tcui-printing-animation__overlay"></div>
      <span className="dqm-tcui-printing-animation__arrow_container">
        <i className="dqm-tcui-printing-animation__arrow"></i>
      </span>
      <span className="dqm-tcui-printing-animation__arrow_container">
        <i className="dqm-tcui-printing-animation__arrow"></i>
      </span>
      <span className="dqm-tcui-printing-animation__arrow_container">
        <i className="dqm-tcui-printing-animation__arrow"></i>
      </span>
    </div>
  );
};

export default PrintingAnimation;
